import React from 'react';

import { LayoutContainerCentered } from 'src/components/LayoutContainerCentered';
import { NavigationBar } from 'src/views/NavigationBar';
import { Loader } from './components/Loader';
import { NavigationBarItems } from './views/NavigationBarItems';
import { PanelWelcome } from './views/PanelWelcome';
import { PanelError } from './views/PanelError';
import { PanelDocument } from './views/PanelDocument';
import { useViewState } from './useViewState';
import { VIEW_TYPE } from './const';
import { useStyles } from './useStyles';

export const SharedPage = () => {
  const styles = useStyles();
  const { activeView, projectData } = useViewState();

  if (activeView === VIEW_TYPE.loading || activeView === VIEW_TYPE.redirecting) {
    return <Loader className="mt-4" />;
  }

  return (
    <>
      <NavigationBar
        className={styles.navigationBar}
        displayLogo
        displayProjectName={!!projectData?.name}
      >
        <NavigationBarItems />
      </NavigationBar>

      <LayoutContainerCentered
        className={styles.pageWrapper}
        data-testid="SharedPage"
      >
        <div>
          <PanelWelcome className="my-3" />
          {activeView === VIEW_TYPE.error && <PanelError className="text-center" />}
          {activeView === VIEW_TYPE.project && <PanelDocument className="mx-7" />}
        </div>
      </LayoutContainerCentered>
    </>
  );
};
